export function accordion() {
    $("body").on("click", ".accordion-heading", function (e) {
        e.preventDefault();

        const $item = $(this).closest(".accordion-item");
        const $accordion = $item.closest(".accordion");

        if ($item.hasClass("opened")) {
            $item.removeClass("opened").find(".hidden-info").slideUp();
        } else {
            $accordion.find(".accordion-item.opened")
                .removeClass("opened")
                .find(".hidden-info")
                .slideUp();

            $item.addClass("opened").find(".hidden-info").slideDown();
        }
    });

    const loadMoreTemplate =
        `<div class="load-more-wrap">
          <button class="button">
            <span><span>Load more</span></span>
          </button>
        </div>`;

    $(".accordion").each(function () {
        const $accordion = $(this);
        const $items = $accordion.find(".accordion-item");
        const maxVisible = $accordion.data("max-visible-items") || 30;

        if ($items.length > maxVisible) {
            $items.slice(maxVisible).addClass("hidden");
            const $loadMore = $(loadMoreTemplate).insertAfter($accordion);

            $loadMore.find(".button").on("click", function (e) {
                e.preventDefault();
                $(this).fadeOut();
                $accordion.find(".accordion-item.hidden").slideDown().removeClass("hidden");
            });
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js